import type { TitleStoryblok } from "@/types/storyblok-blok-types";

import TitleBlokUI from "./TitleBlokUI";

const TitleBlock = ({ blok }: { blok: TitleStoryblok }) => {
  return <TitleBlokUI blok={blok} />;
};

export default TitleBlock;
